
import { Calendar, CreditCard, Wrench, UserCheck, Shield, BarChart3 } from "lucide-react";

export const Benefits = () => {
  const benefits = [
    {
      icon: Calendar,
      title: "Smart Viewing Scheduling",
      description: "Automated scheduling system that syncs with your calendar and sends reminders to both parties.",
      color: "bg-blue-100 text-blue-600"
    },
    {
      icon: CreditCard,
      title: "Automated Rent Tracking",
      description: "Never chase rent again. Automatic payment processing with late fee calculations and reminders.",
      color: "bg-green-100 text-green-600"
    },
    {
      icon: Wrench,
      title: "Maintenance Management",
      description: "Track maintenance requests, assign contractors, and monitor completion with photo documentation.",
      color: "bg-orange-100 text-orange-600"
    },
    {
      icon: UserCheck,
      title: "Seamless Onboarding",
      description: "Digital lease signing, background checks, and move-in documentation all in one place.",
      color: "bg-purple-100 text-purple-600"
    },
    {
      icon: Shield,
      title: "Legal Compliance",
      description: "Stay compliant with local laws and regulations with automated document generation.",
      color: "bg-red-100 text-red-600"
    },
    {
      icon: BarChart3,
      title: "Financial Analytics",
      description: "Comprehensive reports on income, expenses, and property performance metrics.",
      color: "bg-indigo-100 text-indigo-600"
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
              Everything You Need to Manage Properties
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              From tenant screening to rent collection, we've got every aspect of property management covered.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-card rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-border"
              >
                <div className={`inline-flex p-3 rounded-lg ${benefit.color} mb-6`}>
                  <benefit.icon className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-semibold text-card-foreground mb-4">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
